module.exports = __webpack_public_path__ + "static/historico-tab-01e2f54d52c5913efb20855246cb020b.png";